// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"40":"0f526283","453":"f8f6859c"}[chunkId] + ".chunk.js");